import React, { useState } from 'react';
// ADDED IMPORT: Import the new utility functions
import { validateEnquiryForm, submitEnquiryForm } from '../utils/enquiryUtils';

const EnquiryModal = ({ show, onClose }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    mobile: '',
    message: '',
  });
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Handle form field changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    // Clear error for the current field on change
    setErrors((prev) => ({ ...prev, [name]: '' }));
  };

  // The entire previous 'validate' function has been moved to utils/enquiryUtils.js

  // MODIFIED: Handle form submission is now async and uses the utility functions
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Use the utility function for validation
    const { errors: validationErrors, isValid } = validateEnquiryForm(formData); 

    if (isValid) {
      setIsSubmitting(true);
      try {
        // Use the utility function for submission
        const response = await submitEnquiryForm(formData); 
        
        alert(`Success: ${response.message}`);
        
        setFormData({ name: '', email: '', mobile: '', message: '' }); // Clear form
        onClose(); // Close modal

      } catch (error) {
        console.error('Submission Error:', error);
        alert(`Error: ${error.message || 'There was a problem submitting your form.'}`);
      } finally {
        setIsSubmitting(false);
      }
    } else {
      setErrors(validationErrors);
    }
  };

  if (!show) {
    return null;
  }
  
  // Assuming the rest of your form JSX is within the modal-backdrop
  return (
    <div className="modal-backdrop" onClick={onClose}>
        <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
                <h2>Book a Demo</h2>
                <button className="close-btn" onClick={onClose}>&times;</button>
            </div>
            <form onSubmit={handleSubmit} className="enquiry-form">
                <div className="form-group">
                    <label htmlFor="name">Name</label>
                    <input 
                        type="text" 
                        id="name" 
                        name="name" 
                        placeholder='Enter your name...'
                        value={formData.name} 
                        onChange={handleChange} 
                        disabled={isSubmitting}
                    />
                    {errors.name && <p className="error-message">{errors.name}</p>}
                </div>
                
                <div className="form-group">
                    <label htmlFor="email">Email</label>
                    <input 
                        type="email" 
                        id="email" 
                        name="email" 
                        placeholder='Enter your email...'
                        value={formData.email} 
                        onChange={handleChange} 
                        disabled={isSubmitting}
                    />
                    {errors.email && <p className="error-message">{errors.email}</p>}
                </div>

                <div className="form-group">
                    <label htmlFor="mobile">Mobile Number</label>
                    <input 
                        type="tel" 
                        id="mobile" 
                        name="mobile" 
                        placeholder='Enter your Mobile no...'
                        value={formData.mobile} 
                        onChange={handleChange} 
                        disabled={isSubmitting}
                    />
                    {errors.mobile && <p className="error-message">{errors.mobile}</p>}
                </div>

                <div className="form-group">
                    <label htmlFor="message">Message (Optional)</label>
                    <textarea 
                        id="message" 
                        name="message" 
                        rows="2" 
                        placeholder='Insert your query here...'
                        value={formData.message} 
                        onChange={handleChange} 
                        disabled={isSubmitting}
                    ></textarea>
                </div>

                <button 
                    type="submit" 
                    className="submit-btn" 
                    disabled={isSubmitting}
                >
                    {isSubmitting ? 'Sending...' : 'Submit Enquiry'}
                </button>
            </form>
        </div>
    </div>
  );
};

export default EnquiryModal;